<template>
  <!-- 仪器列表 -->
  <div class="byTablePopModel">
    <div class="modelHeader ">
      <div class="headerbut">
        <el-button size="mini" type="primary" @click="createBy">新增</el-button>
        <el-button size="mini" type="primary" @click="exportDoc">导出</el-button>
      </div>
    </div>
    <div class="model-detail">
      <div class="box-detail">
        <span class="box-title">仪器名称：</span>
        <span class="box-content">{{dataModel.instrumentName}}</span>
      </div>
      <div class="box-detail">
        <span class="box-title">型号：</span>
        <span class="box-content">{{dataModel.pattern}}</span>
      </div>
      <div class="box-detail">
        <span class="box-title">仪器编号：</span>
        <span class="box-content">{{dataModel.serialNumber}}</span>
      </div>
    </div>
    <div>
      <span class="box-title" style="margin-left: 10px;">保养日期范围：</span>
      <el-date-picker format="yyyy-MM-dd" size="mini" value-format="yyyy-MM-dd" v-model="date" type="daterange" range-separator="至"
                       start-placeholder="开始日期" end-placeholder="结束日期">
       </el-date-picker>
       <el-button type="primary" size="mini"  @click="inquire">搜索</el-button>
    </div>
    <div class="sysTable">
      <el-table :data="record" height="450" v-loading="loading" style="width: 100%">
        <el-table-column type="index" label="序号" align="center" width="80">
        </el-table-column>
        <el-table-column prop="handleTime" label="保养时间" align="center" min-width="150">
        </el-table-column>
        <el-table-column prop="content" label="维护内容" align="center" min-width="150">
        </el-table-column>
        <el-table-column prop="conclusion" label="维护结论" align="center" min-width="150">
        </el-table-column>
        <el-table-column prop="manageOpinion" label="处理意见" align="center" min-width="150">
        </el-table-column>
        <el-table-column prop="manageUser" label="经手人" align="center" min-width="150">
        </el-table-column>
        <el-table-column prop="states" label="状态" align="center" min-width="150">
          <template slot-scope="scope">
            <span>{{ getStates(scope.row.states) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" align="center" min-width="150">
        </el-table-column>
        <el-table-column label="操作" align="center" width="250">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)" type="text" size="small" ref="childEdit">编辑</el-button>
            <el-popover placement="top" width="160" :ref="scope.$index">
              <p>确认删除该记录？</p>
              <div style="text-align: right; margin: 0">
                <el-button size="mini" type="text" @click="scope._self.$refs[scope.$index].doClose()">取消</el-button>
                <el-button type="primary" size="mini" @click="scope._self.$refs[scope.$index].doClose();;deleteBy(scope.row)">确定</el-button>
              </div>
              <el-button slot="reference" type="text" size="small">删除</el-button>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog append-to-body title="保养处置" :visible.sync="visible" width="800px" :close-on-click-modal="false">
      <byPopModel v-if="visible" :message="popoData" :is-edit="isEdit" @dispose="byChange"></byPopModel>
    </el-dialog>
    <div class="resource-block">
      <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="current"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
    </div>
  </div>
</template>

<script>
import byPopModel from "./byPopModel1";
import {
  addMainta,
  getMaintainList,
  deleteByItem,
  updateMaintainhandle,
  exportMaintain,
} from "@/api/depotApi";
export default {
  name: "byTablePopModel",
  props: {
    dataModel: {
      type: Object,
    },
  },
  components: {
    byPopModel,
  },
  data() {
    return {
      record:[],
      loading: true,
      visible: false,
      popoData: {}, //传参
      current:1,
      total:0,
      size:10,
      date:null,
      options: [
        { value: 0, label: "正常" },
        { value: 1, label: "降级" },
        { value: 2, label: "停用" },
        { value: 3, label: "需维修" },
        { value: 4, label: "需检定" },
        { value: 5, label: "需保养" },
        { value: 6, label: "报废" },
      ],
      isEdit: false // 是否编辑
    };
  },
  created() {
    this.getList();
  },
  methods: {
    handleSizeChange(page){
      this.size = page;
      this.getList()
    },
    handleCurrentChange(page){
      this.current = page;
      this.getList();
    },
    inquire(){
      this.current = 1;
      this.getList()
    },
    getList() {
      let self = this;
      self.loading = true;
      let params ={
        current: self.current,
        size:self.size,
        id:self.dataModel.id
      }
      if (this.date) {
                params.startDate = this.date[0]
                params.endDate = this.date[1]
            }
      getMaintainList(params).then((res) => {
        self.loading = false;
        if (res.code != 200) {
          return;
        }
        self.record = res.data.records;
            self.total = res.data.total;
      }).finally(() => self.loading = false);
    },
    createBy() {
      console.log(this.dataModel);
      this.popoData = this.dataModel;
      this.visible = true;
      this.isEdit = false
    },
    edit(row) {
      this.popoData = {
        ...this.dataModel,
        ...row
      }
      this.visible = true;
      this.isEdit = true
    },
    // 新增或编辑保养记录
    byChange(operation, data) {
      let params ={
        ...data,
        instrumentId:this.dataModel.id
      }
      if (operation) {
        if (!this.isEdit) {
          addMainta(params).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "处理成功",
                type: "success",
              });
            }
            this.getList();
            this.visible = false;
          });
        } else {
          this.updateBy(params)
        }
      } else {
        this.visible = false;
      }
    },
    getStates(val) {
      return this.options.find((item) => {
        return item.value == val;
      }).label;
    },
    // 编辑保养记录
    updateBy(val) {
      updateMaintainhandle(val).then(res => {
        if (res.code == 200) {
          this.getList();
          this.$message.success(res.msg || '修改保养记录成功！')
          this.visible = false;
        } else {
          this.$message.error(res.msg || '修改保养记录失败！')
        }
      })
    },
    deleteBy(val) {
      let self = this;
      deleteByItem(val.id).then((res) => {
        if (res.code != 200) {
          return;
        }
        self.$message({
          message: "删除成功",
          type: "success",
        });
        self.getList();
      });
    },
    exportDoc() {
      exportMaintain(this.dataModel.id).then((res) => {
        this.mixin.blobDownload(res.data,'保养记录.docx')
      });
    },
  },
};
</script>

<style lang="less" scoped>
.byTablePopModel {
  .modelHeader {
    width: 100%;
    .headerTitle {
      text-align: center;
    }
    .headerbut {
      float: right;
      line-height: 50px;
    }
  }
  .model-detail {
    width: 100%;
    display: grid; //网格形式
    grid-template-columns: 33% 33% 33%; //这里表明分为3列
    grid-gap: 10px; //每列的间隔
    .box-detail {
      height: 32px;
      line-height: 32px;
      padding: 6px 12px;
      /*box-shadow: 0 0 15px #0071f1 inset;*/
      border-radius: 6px;
      margin-right: 10px;
      .box-title {
        width: 35%;
      }
      .box-content {
        width: 65%;
      }
    }
  }
}
.resource-block{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/Instrumentmanagemen/components/byTablePopModel.vue